export default {
    getMetamaskWallet: ({metaMaskWallet}) => metaMaskWallet,
    getBinanceWallet: ({binanceWallet}) => binanceWallet,
    getPreloader: ({preloader}) => preloader,
    getSpotDxlnBalance: ({spotBalance}) => +spotBalance.beforeDxln?.amount / Math.pow(10, 18) || 0,
    getSpotUsdcBalance: ({spotBalance}) => parseFloat(+spotBalance.beforeUsdc?.amount / Math.pow(10, 18)).toFixed(2) || 0,
    getSpotPriceDxln: ({spotBalance}) => spotBalance.priceDxln,
    getSpotPriceUsdc: ({spotBalance}) => spotBalance.priceUsdc,
  };